import styled from "@emotion/styled";

const AppTopSpacer = styled.div<{
  pt?: boolean;
}>`
  margin-top: ${(props) => (props.pt ? "1rem" : 0)};
  height: var(--safe-area-inset-top, 0px);
`;

export default AppTopSpacer;
